module.exports = "/_next/static/images/97f8902eea5a67d6f59aa3d57aaaf559-nubanker-eng@0.5x.jpg";